const AnnouncementBarBuilderComponent = {
  name: '_AnnouncementBar_',
  friendlyName: 'Announcement Bar',
  noWrap: true,
  inputs: [
    {
      name: 'items',
      friendlyName: 'Announcement Items',
      type: 'list',
      subFields: [
        {
          name: 'text',
          friendlyName: 'Announcement Copy',
          type: 'string',
          required: true,
          helperText:
            'Required. If blank, this item is skipped entirely. Keep to ~40 characters — longer text gets cut off with "..." on smaller screens.',
        },
        {
          name: 'textBold',
          friendlyName: 'Bold Announcement Copy?',
          type: 'boolean',
          defaultValue: true,
          helperText:
            'On by default. Bold reads better at this size — turn off for a lighter feel.',
        },
        {
          name: 'mobileText',
          friendlyName: 'Mobile Announcement Copy (Optional)',
          type: 'string',
          localized: true,
          helperText:
            'Shorter version for phones (~30 characters). Leave empty to reuse the desktop copy.',
        },
        {
          name: 'subtext',
          friendlyName: 'Subtext (Optional)',
          type: 'string',
          localized: true,
          helperText:
            'Shows after the main copy, separated by "|". ~26 characters max. This shares the line with the main copy, so long text on both will clip.',
        },
        {
          name: 'subtextBold',
          friendlyName: 'Bold Subtext?',
          type: 'boolean',
          defaultValue: false,
          helperText:
            'Off by default so it feels secondary. Turn on to match the main copy weight.',
        },
        {
          name: 'mobileSubtext',
          friendlyName: 'Mobile Subtext (Optional)',
          type: 'string',
          localized: true,
          helperText:
            'Shorter subtext for phones. Leave empty to reuse the desktop subtext.',
        },
        {
          name: 'url',
          friendlyName: 'Link URL (Optional)',
          type: 'url',
          localized: true,
          helperText:
            'Makes the announcement text clickable. Must be a full URL (e.g. "https://www.fabletics.com/sale") or a relative path (e.g. "/sale"). Leave empty for static text.',
        },
        {
          name: 'openInNewTab',
          friendlyName: 'Open Link in New Tab?',
          type: 'boolean',
          defaultValue: false,
          helperText:
            'Only applies if a Link URL is set above. Opens the link in a new tab instead of navigating away.',
        },
        {
          name: 'termsUrl',
          friendlyName: 'Terms URL Link (Optional)',
          type: 'url',
          localized: true,
          helperText:
            'Adds a small link on the right side of the bar. Must be a full URL (e.g. "https://www.fabletics.com/terms"). Takes up horizontal space, so main copy may clip sooner on narrow screens. Always opens in a new tab.',
        },
        {
          name: 'termsUrlLabel',
          friendlyName: 'Terms URL Link Label',
          type: 'string',
          localized: true,
          defaultValue: 'Terms',
          helperText:
            'Label for the terms link — e.g. "Terms", "Details", "See Rules". Keep under 20 characters or it\'ll crowd the main copy.',
        },
      ],
      defaultValue: [
        {
          text: '',
          textBold: true,
          subtextBold: false,
          openInNewTab: false,
          termsUrl: '',
          termsUrlLabel: 'Terms',
        },
      ],
      onChange: (options: any) => {
        const items = options.get('items');
        if (items && items.length > 3) {
          options.set('items', items.slice(0, 3));
          alert('Maximum 3 announcement items.');
        }
      },
      helperText:
        'Up to 3 items. Multiple items rotate every 7 seconds with a slide animation. A single item displays statically with no animation.',
    },
  ],
} as const;

export default AnnouncementBarBuilderComponent;
